<template>
  <div class="inline-flex">
    <vs-icon class="remove-button text-gray hover:text-danger hover:bg-soft rounded cursor-pointer text-center my-auto p-2" icon="cancel" @click="onClick" />
    <vs-divider position="left" class="ml-1 my-auto text-gray">
      <span class="pr-2">{{title}}</span>
    </vs-divider>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true }
  },
  
  methods: {
    onClick() {
      this.$emit('remove-section')
    }
  }
}
</script>

<style scoped>
  .remove-button {
    margin-left: -32px;
  }
</style>
